"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex-column registration-form-container" };
const _hoisted_2 = { class: "registration-subtitle" };
const _hoisted_3 = { class: "flex-column flex-gap" };
const _hoisted_4 = { class: "flex-column flex-gap" };
const _hoisted_5 = { class: "flex-column flex-gap" };
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "flex-column flex-gap" };
const _hoisted_8 = { class: "flex-column flex-gap" };
const _hoisted_9 = { class: "flex-column flex-gap" };
const _hoisted_10 = ["value"];
const vue_3 = require("vue");
const provider_1 = require("../../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'GroupRegistrationForm',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.registrationViewModelInjectKey);
        const userViewModel = (0, vue_3.inject)(provider_1.userRegistrationViewModelInjectKey);
        const groupViewModel = (0, vue_3.inject)(provider_1.groupRegistrationViewModelInjectKey);
        const groupPresenter = (0, vue_3.inject)(provider_1.groupRegistrationPresenterInjectKey);
        const name = (0, vue_3.computed)({
            get: () => groupViewModel?.value.form.name || '',
            set: (v) => groupPresenter?.setField('name', v),
        });
        const address = (0, vue_3.computed)({
            get: () => groupViewModel?.value.form.address || '',
            set: (v) => groupPresenter?.setField('address', v),
        });
        const category = (0, vue_3.computed)({
            get: () => groupViewModel?.value.form.category || null,
            set: (v) => groupPresenter?.setField('category', v),
        });
        const numOfExpectedUsers = (0, vue_3.computed)({
            get: () => groupViewModel?.value.form.numOfExpectedUsers?.toString() ?? '',
            set: (v) => {
                groupPresenter?.setField('numOfExpectedUsers', v === '' ? null : Number(v));
            }
        });
        const numOfExpectedBranches = (0, vue_3.computed)({
            get: () => groupViewModel?.value.form.numOfExpectedBranches?.toString() ?? '',
            set: (v) => {
                groupPresenter?.setField('numOfExpectedBranches', v === '' ? null : Number(v));
            }
        });
        const referrer = (0, vue_3.computed)({
            get: () => groupViewModel?.value.form.referrer || null,
            set: (v) => groupPresenter?.setField('referrer', v),
        });
        const branchCategories = (0, vue_3.computed)(() => {
            return viewModel?.value.branchCategories || [];
        });
        const referrers = (0, vue_3.computed)(() => {
            return viewModel?.value.referrers || [];
        });
        const userName = (0, vue_3.computed)(() => {
            return userViewModel?.value.form.name || '';
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(userName.value) + "様, 会社情報をご入力ください。", 1 /* TEXT */),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    _cache[6] || (_cache[6] = (0, vue_2.createTextVNode)(" 会社名 ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                        class: (0, vue_2.normalizeClass)(["form-input br-5", { 'input-error': (0, vue_2.unref)(groupViewModel)?.errors.name }]),
                        type: "text",
                        placeholder: "会社名"
                    }, null, 2 /* CLASS */), [
                        [vue_2.vModelText, name.value]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    _cache[7] || (_cache[7] = (0, vue_2.createTextVNode)(" 会社の所在地 ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((address).value = $event)),
                        class: (0, vue_2.normalizeClass)(["form-input br-5", { 'input-error': (0, vue_2.unref)(groupViewModel)?.errors.address }]),
                        type: "text",
                        placeholder: "所在地"
                    }, null, 2 /* CLASS */), [
                        [vue_2.vModelText, address.value]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                    _cache[9] || (_cache[9] = (0, vue_2.createTextVNode)(" 業種 ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((category).value = $event)),
                        class: (0, vue_2.normalizeClass)(["form-select br-5", { 'input-error': (0, vue_2.unref)(groupViewModel)?.errors.category }])
                    }, [
                        _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("option", {
                            value: null,
                            disabled: "",
                            selected: "",
                            hidden: ""
                        }, "業種を選んでください。", -1 /* CACHED */)),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(branchCategories.value, (option) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                key: option.Value,
                                value: option.Value
                            }, (0, vue_2.toDisplayString)(option.Japanese), 9 /* TEXT, PROPS */, _hoisted_6));
                        }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */), [
                        [vue_2.vModelSelect, category.value]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    _cache[10] || (_cache[10] = (0, vue_2.createTextVNode)(" 従業員数 ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((numOfExpectedUsers).value = $event)),
                        class: (0, vue_2.normalizeClass)(["form-input br-5", { 'input-error': (0, vue_2.unref)(groupViewModel)?.errors.numOfExpectedUsers }]),
                        type: "number",
                        min: "0",
                        placeholder: "1"
                    }, null, 2 /* CLASS */), [
                        [vue_2.vModelText, numOfExpectedUsers.value]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                    _cache[11] || (_cache[11] = (0, vue_2.createTextVNode)(" 拠点数 ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((numOfExpectedBranches).value = $event)),
                        class: (0, vue_2.normalizeClass)(["form-input br-5", { 'input-error': (0, vue_2.unref)(groupViewModel)?.errors.numOfExpectedBranches }]),
                        type: "number",
                        min: "0",
                        placeholder: "1"
                    }, null, 2 /* CLASS */), [
                        [vue_2.vModelText, numOfExpectedBranches.value]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                    _cache[13] || (_cache[13] = (0, vue_2.createTextVNode)(" oplusを知ったきっかけは何ですか？ ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((referrer).value = $event)),
                        class: (0, vue_2.normalizeClass)(["form-select br-5", { 'input-error': (0, vue_2.unref)(groupViewModel)?.errors.referrer }])
                    }, [
                        _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("option", {
                            value: null,
                            disabled: "",
                            selected: "",
                            hidden: ""
                        }, "以下から選択してください", -1 /* CACHED */)),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(referrers.value, (r) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                key: r.Value,
                                value: r.Value
                            }, (0, vue_2.toDisplayString)(r.Type), 9 /* TEXT, PROPS */, _hoisted_10));
                        }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */), [
                        [vue_2.vModelSelect, referrer.value]
                    ])
                ])
            ]));
        };
    }
});
